var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestimonialsBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 29,
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9499 14.6283L29.9499 13.6531L23.3115 13.6531L23.3115 2.61801e-06L37 3.8147e-06L37 13.5504C37 23.8501 32.4372 29 23.3115 29L23.3115 23.2513C25.6444 22.8749 27.3426 21.9853 28.4061 20.5823C29.4353 19.2136 29.9499 17.2289 29.9499 14.6283ZM6.63838 14.6283L6.63838 13.6531L-2.47303e-06 13.6531L-1.27944e-06 5.80054e-07L13.637 1.77224e-06L13.637 13.5504C13.637 23.8501 9.09133 29 -3.8147e-06 29L-3.31213e-06 23.2513C4.42559 22.6696 6.63838 19.7953 6.63838 14.6283Z",
    fill: "#A52EB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialsBottom);
export default __webpack_public_path__ + "static/media/testimonials-bottom.82fc923b45829b76ef4404055df42b00.svg";
export { ForwardRef as ReactComponent };